import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'

export const Route = createFileRoute('/(test)/test/navigate')({
	component: RouteComponent,
})

function RouteComponent() {
	useEffect(() => {}, [])
	return null
}
